import DocsConfig from '@tencent/docs-config';
import type IDocsConfig from '@tencent/docs-config';
import type { ConfigKeys, GetConfig, RemoveUndefined } from 'config/type/app-config-transformation.type';
import type { IAppConfig } from 'config/type/app-config.interface';
import { updateWebofficeConfig } from './weboffice-config';

export type IAppConfigInstance = IDocsConfig<ConfigKeys, IAppConfig>;

export const getAppConfigInstance = () => {
    const instance: IAppConfigInstance = DocsConfig.getInstance<ConfigKeys, IAppConfig>();
    return instance;
};

const appConfigInstance = getAppConfigInstance();
updateWebofficeConfig(appConfigInstance);
export default appConfigInstance;

// configInstance的值为undefined/boolean，此处对undefined的情况进行了处理。
/**
 * @deprecated
 */
export const setDefaultConfig = (configInstance, defaultConfig) => {
    if (typeof configInstance === 'undefined') return defaultConfig;
    return configInstance;
};

export const getCacConfigByKey = <K extends ConfigKeys>(
    key: K,
    defaultValue: RemoveUndefined<GetConfig<IAppConfig, K>>,
): RemoveUndefined<GetConfig<IAppConfig, K>> =>
    // eslint-disable-next-line implicit-arrow-linebreak
    appConfigInstance.getConfig(key) ?? defaultValue;

// const url = getCacConfig('custom.addon.iframeUrl', ''); // string;
// const enableRemotePlay = getCacConfig('titlebar.remotePlay', false); // boolean
// const position = getCacConfig('custom.player.position', 'left'); // 'left' | 'right'
// const shouldInsertLatex = getCacConfig('custom.toolbarFileMenu.insertLatex', false); // boolean
// const urls = getCacConfig('npm.@tencent/tencent-doc-report.interceptorIgnoreUrls', ['']); // string[]

